/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteInitiativePlannedFocusDay$Params {
  initiativeId: string;
  id: string;
}

export function deleteInitiativePlannedFocusDay(http: HttpClient, rootUrl: string, params: DeleteInitiativePlannedFocusDay$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteInitiativePlannedFocusDay.PATH, 'delete');
  if (params) {
    rb.path('initiativeId', params.initiativeId, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteInitiativePlannedFocusDay.PATH = '/initiative/{initiativeId}/plannedfocusday/{id}';
